module.exports = __webpack_public_path__ + "media/images/lb/117-d150b227182835aca577361d667749d1.svg";